import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftTypeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--aircraft-type']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
